import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface IDevice {
    __type: string
    availableHMRTicketPrinters: string[]
    availableLabelPrinters: string[]
    availableScales: string[]
    availableTemperatureProbes: string[]
    availableTicketPrinters: string[]
    deviceId: string
}

export interface IDeviceState {
    _device: Partial<IDevice>
    _deviceInfoPromise: Promise<Partial<IDevice>>
}

export const initialState: IDeviceState = {
    _device: {
        __type: 'com.amazon.ihmbees.coral#RovingAssociateDevice',
        availableHMRTicketPrinters: [],
        availableLabelPrinters: [],
        availableScales: [],
        availableTemperatureProbes: [],
        availableTicketPrinters: [],

    },
    _deviceInfoPromise: null,
}

export const deviceSlice = createSlice({
    name: 'deviceSlice',
    initialState,
    reducers: {
        setDeviceState: (state, action: PayloadAction<Partial<IDevice>>) => { state._device = action.payload },
        cacheDeviceInfoPromise: (state, action: PayloadAction<Promise<Partial<IDevice>>>) => {
            state._deviceInfoPromise = action.payload
        },
        reset: (state) => {
            state._device = null
            state._deviceInfoPromise = null
        },
    },
})

export const {
    cacheDeviceInfoPromise,
    setDeviceState,
    reset,
} = deviceSlice.actions

export default deviceSlice.reducer
